import instance from "../../utils/axios";

export const sendOtp = async (formData) => {
  return await instance.post("/send-otp", formData);
};
